import styled from 'styled-components';
import { Upload } from 'antd';

export const UploadWrapper = styled.div`
  border: 1px solid var(--clr-border-grey-100);
  border-radius: 5px;
  padding: 10px;
  background-color: var(--clr-container-bg);
  width: 100%;
`;

export const StyledUpload = styled(Upload)`
  width: 100%;
  max-width: 30px;
  .ant-upload-select {
    width: 100%;
  }
`;

export const UploadedFile = styled.div`
  border: 1px solid var(--clr-border-grey-100);
  border-radius: 5px;
  padding: 5px 10px;
  margin-top: 15px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  .attached-file-icon {
    flex-shrink: 0;
    font-size: 18px;
    color: var(--clr-icon-color);
  }
  .attached-file-name {
    max-width: 185px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
